import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import CssBaseLine from '@mui/material/CssBaseline';
import { ThemeProvider } from '@mui/material';
import theme from 'theme';
import { Helmet } from 'react-helmet';
import { TheMoreContainer } from 'components/Pages';

function App() {
  const currentUrl = document.location.href;
  return (
    <ThemeProvider theme={theme}>
      <Helmet>
        <title>더모아 주유계산기</title>
        <link
          rel="icon"
          href="https://www.shinhancard.com/pconts/images/ico_favicon96.ico"
        />
        {/* URL 정보 */}
        <meta property="og:url" content={currentUrl} />
        {/* title 정보 */}
        <meta property="og:title" content="더모아 주유계산기" />
        {/* 페이지 상세 정보 */}
        <meta property="og:description" content="신한 더모아카드 주유계산기" />
        {/* 페이지 대표 이미지 정보 */}

        {/* 트위터 메타 정보 */}
        <meta name="twitter:title" content="더모아 주유계산기" />
        <meta name="twitter:description" content="신한 더모아카드 주유계산기" />
      </Helmet>
      <CssBaseLine>
        <Router>
          <Routes>
            <Route path="/" element={<TheMoreContainer />} />
          </Routes>
        </Router>
      </CssBaseLine>
    </ThemeProvider>
  );
}

export default App;
